import { render, staticRenderFns } from "./JcomNationalBoardMembersList.vue?vue&type=template&id=54b3ed43"
import script from "./JcomNationalBoardMembersList.vue?vue&type=script&lang=js"
export * from "./JcomNationalBoardMembersList.vue?vue&type=script&lang=js"
import style0 from "./JcomNationalBoardMembersList.vue?vue&type=style&index=0&id=54b3ed43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports